import { SettingsSection, SettingsSwitchField } from '../../../Settings'
import {
  CALENDAR_SETTINGS_TASK_TYPES_SECTION_DESCRIPTION_KEY,
  CALENDAR_SETTINGS_TASK_TYPES_SECTION_TITLE_KEY,
  QA_NAME_CALENDAR_SETTINGS_TASK_TYPES,
} from '../../CalendarSettings.constants'
import { DueDatesSection } from '../DueDatesSection'

import { CALENDAR_SETTINGS_FORM_SKELETON_SWITCH_ROWS_LENGTH } from './CalendarSettingsFormSkeleton.constants'

import * as styles from './CalendarSettingsFormSkeleton.module.css'

function CalendarSettingsFormSkeleton() {
  return (
    <div className={styles.CalendarSettingsFormSkeleton}>
      <SettingsSection
        descriptionKey={CALENDAR_SETTINGS_TASK_TYPES_SECTION_DESCRIPTION_KEY}
        qaName={QA_NAME_CALENDAR_SETTINGS_TASK_TYPES}
        titleKey={CALENDAR_SETTINGS_TASK_TYPES_SECTION_TITLE_KEY}
      >
        <div className={styles.body}>
          {Array.from({
            length: CALENDAR_SETTINGS_FORM_SKELETON_SWITCH_ROWS_LENGTH,
          }).map((_, index) => (
            <SettingsSwitchField
              isLoading
              className={styles.switchField}
              key={index}
            />
          ))}
        </div>
      </SettingsSection>
      <DueDatesSection isLoading />
    </div>
  )
}

export default CalendarSettingsFormSkeleton
